/**
 * 인증 관련 쿠키 유틸리티 함수들
 */

/**
 * 인증 관련 쿠키 삭제 헬퍼 함수
 * SameSite와 Secure 속성을 고려한 완전한 쿠키 삭제
 */
export const clearAuthCookies = () => {
  // 인증 관련 쿠키명 - Spring Security와 OAuth2 쿠키 포함
  const authCookieNames = [
    'JSESSIONID', 
    'REMEMBER_ME', 
    'oauth2_auth_request', 
    'oauth2_state',
    'SPRING_SECURITY_REMEMBER_ME_COOKIE',
    'XSRF-TOKEN',
    'CSRF-TOKEN'
  ];
  
  const authServerDomain = new URL(import.meta.env.VITE_AUTH_SERVER_URL || 'https://auth.ugot.uk').hostname;
  const currentDomain = window.location.hostname;
  
  // 다양한 도메인과 속성 조합으로 쿠키 삭제 시도
  const domains = [
    currentDomain,
    `.${currentDomain}`,
    authServerDomain,
    `.${authServerDomain}`,
    'ugot.uk',
    '.ugot.uk'
  ];
  
  const paths = ['/', '/oauth2', '/login', '/logout'];
  
  authCookieNames.forEach(cookieName => {
    domains.forEach(domain => {
      paths.forEach(path => {
        // 기본 삭제
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; domain=${domain}`;
        
        // Secure 속성 추가 삭제
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; domain=${domain}; Secure`;
        
        // SameSite=None + Secure 조합 삭제
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; domain=${domain}; SameSite=None; Secure`;
        
        // SameSite=Lax 삭제
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; domain=${domain}; SameSite=Lax`;
        
        // SameSite=Strict 삭제
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; domain=${domain}; SameSite=Strict`;
      });
    });
    
    // 도메인 없이도 삭제 시도
    paths.forEach(path => {
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}`;
    });
  });
  
  // 모든 쿠키 확인 및 강제 삭제
  const allCookies = document.cookie.split(';');
  allCookies.forEach(cookie => {
    const cookieName = cookie.split('=')[0].trim();
    if (authCookieNames.some(authName => cookieName.includes(authName) || authName.includes(cookieName))) {
      // 발견된 인증 관련 쿠키 강제 삭제
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
      console.log(`[AuthUtils] 강제 삭제된 쿠키: ${cookieName}`);
    }
  });
  
  console.log('[AuthUtils] 인증 관련 쿠키 완전 삭제 완료');
};